import {useWebSocket} from "../../context/WebSocketContext";

const GameControlPortalMaster = () => {
    const {
        requestGames,
        games,
    } = useWebSocket();

    const handleRequestGames = () => {
        requestGames();
    };


    return(
        <div>
            <table border="1" style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
                <thead>
                <tr>
                    <th>Game ID</th>
                    <th>Events</th>
                </tr>
                </thead>
                <tbody>
                {games.map((game) => (
                    <tr key={game.id}>
                        <td>{game.id}</td>
                        <td>
                            {game.events && game.events.length > 0 ? (
                                <ul>
                                    {game.events.map((event, index) => (
                                        <li key={index}>{event}</li>
                                    ))}
                                </ul>
                            ) : (
                                "" // Empty cell for null or empty events
                            )}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}
export default GameControlPortalMaster;